import { render, staticRenderFns } from "./PaymentMethodCupo.vue?vue&type=template&id=4c067807"
import script from "./PaymentMethodCupo.vue?vue&type=script&lang=js"
export * from "./PaymentMethodCupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports